import React from "react";

const SettlementHeader = () => {

    return (

        <div className="settlement-header">

            <div>

                <h2>Settlements & Payouts</h2>

                <p>

                    Manage provider settlements, payouts and transactions.

                </p>

            </div>

        </div>

    );

};

export default SettlementHeader;